// Copyright (c) StrangeBee 2023

import { LanguageSwitcherContext } from '@Lang/LanguageSwitcherContext';
import { useGetSettings } from '@Queries/UISettingsQueries';
import moment from 'moment';
import useLocalStorage, { LocalStorageKeys } from './useLocalStorage';
import { useCallback, useContext } from 'react';

export type UseFormatDateReturn = (date: number) => string;

export const DEFAULT_DATE_FORMAT = 'DD/MM/YYYY HH:mm';

export const useFormatDate = (): UseFormatDateReturn => {
    const { data: settingsData } = useGetSettings();

    const { storage } = useLocalStorage<{ defaultDateFormat: string }>({
        key: LocalStorageKeys.OPTIONS,
        initialValue: {
            defaultDateFormat: settingsData?.defaultDateFormat || DEFAULT_DATE_FORMAT,
        },
    });

    const { defaultDateFormat = DEFAULT_DATE_FORMAT } = storage || settingsData || {};
    const { language } = useContext(LanguageSwitcherContext);

    const formatDate = useCallback(
        (date: number): string => {
            const m = moment(date).locale(language);
            return m.isValid() ? m.format(defaultDateFormat).valueOf() : '';
        },
        [defaultDateFormat, language],
    );

    return formatDate;
};
